import React from 'react';

import { ThemeProvider } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { ContributeSectionSunrise } from './components/ContributeSection';
import { HeroSection } from './components/HeroSection';
import { HowToSectionSunrise } from './components/HowToSection';
import { LocalSection } from './components/LocalSection';
import { TrendingSectionSunrise } from './components/TrendingSection';

export function PageBody(): React.JSX.Element {
	return (
		<ThemeProvider>
			<HeroSection />

			<HowToSectionSunrise />

			<div className="container space-y-16 py-6 md:space-y-28 md:py-[93px]">
				<ClientRender placeholder={<Loader size="m" my={256} mx="auto" />}>
					<LocalSection />
				</ClientRender>

				<TrendingSectionSunrise />

				<ContributeSectionSunrise />
			</div>
		</ThemeProvider>
	);
}
